import { Nullable } from "@core/domain/types/nullable.type";
import { ToastManagerStore } from "@core/presentacion/component/feedback/toast-manager/toast-manager.store";
import { EntityRepository } from "@entity/data/repositories/entity.repository";
import { GlobalEntityRepository } from "@entity/data/repositories/global-entity.repository";
import { EditEntity } from "@entity/domain/models/edit-entity.model";
import { Entity } from "@entity/domain/models/entity.model";
import { inject, injectable } from "inversify";

@injectable()
export class EditEntityUseCase {
    constructor(
        @inject(EntityRepository)
        private readonly entityRepository: EntityRepository,
        @inject(GlobalEntityRepository)
        private readonly globalEntityRepository: GlobalEntityRepository,
    ) {}

    async execute(entity: EditEntity): Promise<Nullable<Entity>> {
        const editResult = await this.entityRepository.update(entity);

        if (editResult.isLeft()) {
            ToastManagerStore.error(editResult.getLeftOrThrow().message);
        }

        this.globalEntityRepository.getAll();

        return editResult.fold(
            () => null,
            (editedEntity) => editedEntity,
        );
    }
}
